import Vue from "vue";
import VueRouter from "vue-router";
import Inicio from "@/views/Inicio.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Inicio",
    component: Inicio,
  },
  {
    path: "/galeria",
    name: "Galeria",
    component: () => import("../views/Galeria.vue"),
  },
  {
    path: "/diagnostico",
    name: "Diagnostico",
    component: () => import("../views/Diagnostico.vue"),
  },
  {
    path: "/propuesta",
    name: "Propuesta",
    component: () => import("../views/Propuesta.vue"),
  },
  {
    path: "/productos-de-investigacion",
    name: "Productos de Investigacion",
    component: () => import("../views/ProductosInvestigacion.vue"),
  },
  {
    path: "/creditos",
    name: "Creditos",
    component: () => import("../views/Creditos.vue"),
  },
  {
    path: "/creditos/:id",
    name: "Investigadores",
    component: () => import("../views/DetalleInvestigadorxs.vue"),
    props: true,
  },
  {
    path: "**",
    name: "Página no encontrada titulo grandotototototote",
    component: () => import("@/views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0, behavior: "smooth" };
  },
});

export default router;
